import { Icon, IconProps } from '@chakra-ui/react'

export default function UserSupportBalloonIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49613 12.7501C5.50664 11.3713 6.63099 10.2611 8.00978 10.2681C9.38856 10.2751 10.5016 11.3966 10.4982 12.7754C10.4947 14.1542 9.37601 15.2702 7.9972 15.2702C7.33107 15.2686 6.69296 15.0019 6.22373 14.5291C5.75449 14.0563 5.4927 13.4162 5.49613 12.7501V12.7501Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9996 10.2491C13.8983 10.2485 13.8067 10.3091 13.7676 10.4025C13.7284 10.4959 13.7495 10.6037 13.8209 10.6755C13.8924 10.7473 14 10.769 14.0937 10.7303C14.1873 10.6917 14.2484 10.6004 14.2484 10.4992C14.2489 10.4329 14.2229 10.3692 14.1761 10.3222C14.1294 10.2752 14.0659 10.2489 13.9996 10.2491"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1129 10.2491C17.0116 10.2485 16.92 10.3091 16.8809 10.4025C16.8417 10.4959 16.8628 10.6037 16.9342 10.6755C17.0056 10.7473 17.1133 10.769 17.2069 10.7303C17.3006 10.6917 17.3616 10.6004 17.3616 10.4992C17.3621 10.4329 17.3361 10.3692 17.2894 10.3222C17.2427 10.2752 17.1791 10.2489 17.1129 10.2491"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.99609 20.8785V20.2532C3.00013 18.8736 4.11752 17.7562 5.49714 17.7522H10.4992C11.8788 17.7562 12.9962 18.8736 13.0003 20.2532V20.8785C12.9992 21.2234 12.7199 21.5027 12.375 21.5037H3.62135C3.27645 21.5027 2.9971 21.2234 2.99609 20.8785V20.8785Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.27344 6.4975C10.0305 3.98255 13.2213 2.90611 16.1428 3.84275C19.0642 4.7794 21.0344 7.51047 21.0015 10.5782C20.9687 13.646 18.9407 16.3343 15.9999 17.2083"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
